<p>store-layout works!</p>
<!-- store-layout.component.html -->
<div class="store-layout">
  <header class="store-header">
    <h1>Mi Tienda</h1>
    <!-- Podrías poner un navbar específico de la tienda -->
  </header>

  <main class="store-main">
    <!-- El router-outlet es crucial para que las rutas hijas se muestren aquí -->
    <router-outlet></router-outlet>
  </main>

  <footer class="store-footer">
    © 2025 Mi Tienda
  </footer>
</div>
